import React, { useState } from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import { IDevice } from '../../interfaces';

const MapsFixed = Map as any;
const MarkerFixed = Marker as any;

class MapContainer extends React.Component<any, any> {
    private drawingManager: any;

    constructor(props: any) {
        super(props);

        console.log(props);

        this.state = {
            matchedDevices: []
        };

        this.drawingManager = null;

        this.onOverlayComplete = this.onOverlayComplete.bind(this);
    }

    componentWillUnmount() {
        console.log('Unmount');
    }

    onOverlayComplete(event: any) {
        const poly = new this.props.google.maps.Polygon({
            paths: event.overlay.getPaths()
        });
        const matchedDevices = [...this.state.matchedDevices];
        for (const d of this.props.allDevices) {
            if (
                d.Shop &&
                this.props.google.maps.geometry.poly.containsLocation(
                    { lat: parseFloat(d.Shop.lat), lng: parseFloat(d.Shop.long) },
                    poly
                )
            ) {
                matchedDevices.push(d);
            }
        }

        console.log(matchedDevices);
        this.setState({ matchedDevices });
    }

    render() {
        const shops: any = {};

        for (const d of this.state.matchedDevices) {
            if (!shops[d.Shop.id]) {
                shops[d.Shop.id] = d.Shop;
            }
        }

        return (
            <div style={{ width: '100%' }}>
                <MapsFixed
                    containerStyle={{
                        position: 'relative',
                        width: '100%',
                        height: 'calc(100% - 30px)'
                    }}
                    onReady={(_: any, map: any) => {
                        this.drawingManager = new this.props.google.maps.drawing.DrawingManager({
                            drawingMode: this.props.google.maps.drawing.OverlayType.POLYGON,
                            drawingControl: true,
                            drawingControlOptions: {
                                position: this.props.google.maps.ControlPosition.TOP_CENTER,
                                drawingModes: [this.props.google.maps.drawing.OverlayType.POLYGON]
                            },
                            polygonOptions: {
                                editable: false
                            }
                        });

                        this.drawingManager.setMap(map);
                        this.props.google.maps.event.addListener(
                            this.drawingManager,
                            'overlaycomplete',
                            this.onOverlayComplete
                        );
                    }}
                    zoom={6}
                    initialCenter={{ lat: 48.8588377, lng: 2.2770207 }}
                    google={this.props.google}
                    style={{ height: '100%', width: '100%', position: 'relative' }}
                >
                    {Object.values(shops).map((s: any) => (
                        <MarkerFixed
                            key={s.id}
                            position={{
                                lat: parseFloat(s.lat),
                                lng: parseFloat(s.long)
                            }}
                        />
                    ))}
                </MapsFixed>
                <button
                    onClick={() => this.props.onAdd(this.state.matchedDevices)}
                    className="btn btn-info"
                    style={{ width: 'fit-content', marginLeft: 'auto', marginTop: 10 }}
                >
                    Ajouter
                </button>
            </div>
        );
    }
}

const MapWrapper = GoogleApiWrapper({
    apiKey: 'AIzaSyAWfIRigNcERfybYb4_YEmOxY3GEFH9tq4',
    libraries: ['drawing', 'places']
})(MapContainer);

export const DrawMap = (props: {
    close: () => void;
    onAddDevices: (devices: IDevice[]) => void;
    allDevices: IDevice[];
}) => {
    const [state, setState] = useState({
        closing: false
    });

    return (
        <div
            className={`modal-background${state.closing ? ' closing' : ''}`}
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    setState({
                        ...state,
                        closing: true
                    });

                    setTimeout(props.close, 200);
                }
            }}
        >
            <div className="modal">
                <div className="content-map">
                    <h6>Dessiner sur la carte</h6>
                    <div className="map">
                        <MapWrapper allDevices={props.allDevices} onAdd={props.onAddDevices} />
                    </div>
                </div>
            </div>
        </div>
    );
};
